import { Injectable } from "@angular/core";
import { catchError, Observable, of, ReplaySubject, tap } from "rxjs";
import { environment } from "@env/environment";
import { HttpClient } from "@angular/common/http";
import { EntitySuperior } from "./entity-superior.interface";

@Injectable()
export class EntitySuperiorService {

    baseUrl = environment.administration_url + '/market-level-organizations';
    private _entitySuperior: ReplaySubject<EntitySuperior> = new ReplaySubject<EntitySuperior>(1);
    private _entitiesSuperior: ReplaySubject<EntitySuperior[]> = new ReplaySubject<EntitySuperior[]>(1);
    private _metadata: ReplaySubject<any> = new ReplaySubject<any>(1);

    set entitySuperior(value: EntitySuperior) {
        this._entitySuperior.next(value);
    }

    get entitySuperior$() {
        return this._entitySuperior.asObservable();
    }

    set entitiesSuperior(value: EntitySuperior[]) {
        this._entitiesSuperior.next(value);
    }

    get entitiesSuperior$() {
        return this._entitiesSuperior.asObservable();
    }

    set metadata(value: any) {
        this._metadata.next(value);
    }

    get metadata$() {
        return this._metadata.asObservable();
    }


    constructor(
        private _httpClient: HttpClient
    ) { }

    create(entitySuperior: EntitySuperior): Observable<EntitySuperior> {
        return this._httpClient.post<EntitySuperior>(`${this.baseUrl}`, entitySuperior)
        .pipe(
            tap((entitySuperior) => {
                this.entitySuperior = entitySuperior;
                return (entitySuperior);
            }),
            catchError(() => of({} as EntitySuperior))
        );
    }

    getEntitiesSuperior(): Observable<EntitySuperior[]> {
        return this._httpClient.get<EntitySuperior[]>(`${this.baseUrl}`)
        .pipe(
            tap((response : any) => {
                this.entitiesSuperior = response?.content.map((entitySuperior: EntitySuperior) => {
                    return entitySuperior;
                });
                this.metadata = response;
                return response;
            }),
            catchError(() => of([] as EntitySuperior[]))
        );
    }

    getEntitySuperior(id: number): Observable<EntitySuperior> {
        return this._httpClient.get<EntitySuperior>(`${this.baseUrl}/${id}`)
        .pipe(
            tap((entitySuperior) => {
                this.entitySuperior = entitySuperior;
                return (entitySuperior);
            }),
            catchError(() => of({} as EntitySuperior))
        );
    }


    updateEntitySuperior(entitySuperior: EntitySuperior): Observable<EntitySuperior> {
        return this._httpClient.put<EntitySuperior>(`${this.baseUrl}/${entitySuperior.id}`, entitySuperior)
        .pipe(
            tap((entitySuperior) => {
                this.entitySuperior = entitySuperior;
                return (entitySuperior);
            }),
            catchError(() => of({} as EntitySuperior))
        );
    }
}